import { render, staticRenderFns } from "./FormCampos.vue?vue&type=template&id=11f21c1e"
import script from "./FormCampos.vue?vue&type=script&lang=js"
export * from "./FormCampos.vue?vue&type=script&lang=js"
import style0 from "./FormCampos.vue?vue&type=style&index=0&id=11f21c1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports